import gql from 'graphql-tag';

export default gql`
  fragment sensesDealCreateActivityFragment on SensesDealCreateActivity {
    sensesDealId
  }
`;
